export default "__VITE_ASSET__DhGogHOO__"